import React, { Component } from 'react';
import { connect } from "react-redux";
import { CardColumns } from 'react-bootstrap'
import axios from "axios";
import configData from "../../config/config.json";

import CommonTop from "../top/CommonTop";

import AlertHistoryBig from './AlertHistoryBig';
import AlertListBig from './AlertListBig';

import ContactUsBig from './ContactUsBig';
import Disclaimer from './Disclaimer';
import LatestNews from './LatestNews';
import Links from './Links';
import LoginPageSlides from './LoginPageSlides';
import { LOADING_STATUES } from "../constants/constants";
import Loading from '../common/modal/Loading';

import { handleError } from '../../redux/actions/commonStuff';
import ContactTenants from './ContactTenants';
import SkipLink from '../common/function/SkipLink';

const mapStateToProps = state => {
  return {
    currentUser: state.currentUserReducer,
    multiTenantSettings: state.countyConfigMultiTenantSettingsReducer,
    language: state.languageReducer ? state.languageReducer : 'ENGLISH',
  };
}

const matchDispatchToProps = (dispatch) => {
  return {
    handleLockout: (lockout) => dispatch({ type: 'SET_LOCKOUT_IN_PLACE', lockout })
  }
}

class HomeBig extends Component {

  state = {
    contactUsCard: false,
    disclaimerCard: false,
    latestNewsCard: false,
    linksCard: false,
    loginSlidesCard: false,

    numberOfSlides: 0,
    contactPhone: '',
    contactEmail: '',

    multiTenantList: [],
    loadingStatus: ""
  }

  showLoading = () => {
    if (this.state.loadingStatus === "") {
      this.setState({
        loadingStatus: LOADING_STATUES.LOADING
      })
      return true;
    }
    return false;
  }

  hideLoading = (message, status) => {
    if (status === 'ERROR') {
      this.setState({
        loadingStatus: "",
        submitMessage: ""
      })
    } else {
      this.setState({
        loadingStatus: "",
        submitMessage: message
      })
    }
  }

  componentDidMount() {

    this.showLoading();

    axios.get(configData.LANDNOTIFICATION_SERVER_URL + "home/all", { withCredentials: true })
      .then(
        (response) => {
          this.props.handleLockout(response.data.lockout);

          const content = response.data.content;

          let multiTenantList = [];
          if (content.multiTenantList && content.multiTenantList.paragraphs && content.multiTenantList.paragraphs.length > 0) {
             multiTenantList = content.multiTenantList.paragraphs;
          }

          let alertHistoryEvents = content.alertHistory.outgoingEvents;

          this.setState({
            contactUsCard: content.selections.contactUs,
            disclaimerCard: content.selections.disclaimer,
            latestNewsCard: content.selections.latestNews,
            linksCard: content.selections.links,
            loginSlidesCard: content.selections.loginSlides,
            numberOfSlides: content.numberOfSlides.numberOfSlides,
            contactPhone: content.common.contactPhone,
            contactEmail: content.common.contactEmail,
            multiTenantList,
            alertHistoryEvents
          },
            function () {   // callback function after the state is set
              this.hideLoading();
            });
        },
        (error) => {
          handleError(error, this.props.history);
        }
      );
  }


  render() {
    let myAlertsRef = React.createRef();
    return (
      <>
        <SkipLink href={'#expandAlertList'} description='Skip to My Alerts' contentRef={myAlertsRef} />
        <CommonTop history={this.props.history} />
        <main>
        <div  style={{ paddingBottom: 2, marginLeft: 10, marginRight: 6, marginTop: 2 }} >
          <CardColumns style={{ marginTop: 20, marginLeft: 50, marginRight: 50 }}> 
            <AlertListBig skipRef={myAlertsRef}  key={this.props.language + "MYALERTS"} language={this.props.language}  history={this.props.history} />
            <AlertHistoryBig alertHistoryEvents={this.state.alertHistoryEvents} />
            {
              this.state.loginSlidesCard &&
              <LoginPageSlides numberOfSlides={this.state.numberOfSlides} />
            }
            {
              this.state.latestNewsCard &&
              <LatestNews key={this.props.language + "NEWS"} language={this.props.language}  />
            }
            {
              this.state.linksCard &&
              <Links key={this.props.language + "LINKS"} language={this.props.language}  />
            }
            {
              this.state.contactUsCard && this.props.multiTenantSettings.multiTenant !== true &&
              <ContactUsBig contactEmail={this.state.contactEmail} contactPhone={this.state.contactPhone} ></ContactUsBig>
            }
            {
              this.state.contactUsCard && this.props.multiTenantSettings.multiTenant === true &&
              <ContactTenants multiTenantList={this.state.multiTenantList} ></ContactTenants>
            }
            {
              this.state.disclaimerCard &&
              <Disclaimer key={this.props.language + "DISCLAIMER"} language={this.props.language} />
            }
          </CardColumns>
        </div>
       </main>
        <Loading loadingIndicator={this.state.loadingStatus === LOADING_STATUES.LOADING} />
      </>
    )
  }
}

export default connect(mapStateToProps, matchDispatchToProps)(HomeBig);